export const SUBSCRIBE_POPUP_COOKIE = {
  SHOW_AFTER: 'ebac_subscribe_popup_show_after',
  NEVER_SHOW: 'ebac_subscribe_popup_never_show',
};

export function setSubscribePopupShowAfter(lifetimeSeconds) {
  const date = new Date();
  date.setTime(date.getTime() + lifetimeSeconds * 1000);
  document.cookie = `${
    SUBSCRIBE_POPUP_COOKIE.SHOW_AFTER
  }=true; expires=${date.toUTCString()}; path=/`;
}

export function setSubscribePopupNeverShow() {
  document.cookie = `${SUBSCRIBE_POPUP_COOKIE.NEVER_SHOW}=true; path=/`;
}

export function getSubscribePopupCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
